import React, { Component } from 'react';
import styled from 'styled-components';

const Div = styled.div`
    iframe{
        height: 60vh;
        width: 100%; 
        frameBorder: 0; 
        border: 0; 
        allowfullscreen: ; 
        aria-hidden: false; 
        tabindex: 0;
    }
    @media (max-width: 425px){
        .div{
            margin: 20px 40px;
        }
    }
`

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class Mapa extends Component {
  render() {
    return (
        <Div>
            <div style={{ height: '60vh', width: '100%' }}>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.7872227177613!2d13.256337914370569!3d-8.991717195044858!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1a521e7d8f169b0b%3A0x1648aa5acb2128b8!2sINAAREES!5e0!3m2!1spt-PT!2sao!4v1597653294103!5m2!1spt-PT!2sao"></iframe>
            </div>
      </Div>
    );
  }
}

export default Mapa;